export default __webpack_public_path__ + "media/zurb/img/icons/favicon/mstile-70x70-1eccfa1337c35f93cd26483bebc10501.png";